/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import ApplicationHeader from "./ApplicationHeader2";
import Login from "../../registration_login/components/Login";
import Home from "../../common/components/Home";
import Registration from "../../registration_login/components/Registration";
import CandidateContainer from "./CandidateContainer";
import NotFound from "./NotFound";
import ForgotPassword from "../../registration_login/components/ForgotPassword";
import ForgotUserName from "../../registration_login/components/ForgotUserName";
import Loader from "./Loader";
import ApplicationFooter from "./ApplicationFooter";
import SessionTimeOut from "./SessionTimeOut";
import { useDispatch } from "react-redux";
import API from "../../helpers/API";
import { hideLoader, showLoader } from "../actions/commonActions";
import { isLoaderApplicable } from "../../helpers/util";
import ForgotEmailandMobile from "../../home/components/ForgotEmailandMobile";
import GrievanceForm from "../../common/components/GrievanceForm";
import AdminLogin from "./AdminLogin";
import AdminContainer from "./AdminContainer";
import AdminHeader from "../../admin/components/AdminHeader";
import QualificationNameForm from './../../admin/masterManagement/components/QualificationNameForm';
import QualificationSubjectForm from './../../admin/masterManagement/components/QualificationSubjectForm';
import ChangePassword from "../../admin/usermanagement/components/ChangePassword";


const AppLayout = (props) => {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //     API.interceptors.request.use(async (request) => {
  //         if (isLoaderApplicable(request.url)) {
  //             dispatch(showLoader());
  //         }
  //         return request;
  //     });

  //     API.interceptors.response.use(
  //         async (response) => {
  //             dispatch(hideLoader());
  //             return response;
  //         },
  //         async (error) => {
  //             dispatch(hideLoader());
  //             throw error;
  //         }
  //     );
  // }, [dispatch]);
  const location = useLocation()
  const isAdmin = location.pathname.split('/')[1] === 'oasadmin'
  return (
    <div>
      {
        isAdmin ?
          <AdminHeader />
          :
          <ApplicationHeader {...props} />
      }
      <Routes>
        <Route path="*" element={<Navigate to="/candidate/login" />} />
        <Route path="/candidate/login" element={<Home />} />
        <Route path="/oasadmin/qualificationform" element={<QualificationNameForm />} />
        <Route path="/oasadmin/qualificationsubjectform" element={<QualificationSubjectForm />} />
        <Route path="/oasadmin/*" element={<AdminContainer />} />
        <Route path="/candidate/registration" element={<Registration />} />
        {/* <Route path="/candidate/grievance" element={<GrievanceForm />} /> */}
        <Route path="/candidate/main" element={<CandidateContainer />} />
        <Route path="/candidate/forgotPassword" element={<ForgotPassword />} />
        {/* <Route path="/oasadmin/changePassword" element={<ChangePassword />} /> */}
        <Route
          path="/candidate/forgotEmailMobile"
          element={<ForgotEmailandMobile />}
        />
        <Route path="/candidate/forgotlogin" element={<ForgotUserName />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ApplicationFooter />
      <Loader />
      <SessionTimeOut {...props} />
    </div>
  );
};

export default AppLayout;
